import { helper } from '@ember/component/helper';
import { get } from '@ember/object';

// Helper to correctly either:
//
// (a) return an object property if it exists, even for cases when the key has dots, or
// (b) traverse through an object to find the right property using Ember's `get`.
//
// For example, given an object like:
//
// {
//  nested: {
//    key: 'nested value'
//  },
//  'dotted.key': 'dotted value'
// }
//
// ... this helper will return `dotted value` for `dotted.key` and `nested value` for `nested.key`.

export function propertyGet([object, key]) {
  // eslint-disable-next-line no-prototype-builtins
  if (object.hasOwnProperty(key)) {
    return object[key];
  }

  return get(object, key);
}

export default helper(propertyGet);
